import React, { useState } from "react";
import { Button, Col, Modal, Row, Spin, Form, notification } from "antd";
import { companyService } from "../../../services/";
import { userServices } from "../../../services/";
import InputField from "../../input-field";
import SelectField from "../../select-field";
import ModalDeactiveUser from "../../modals/user/deactive-user.js";
import i18n from "i18next";

const ROLE_COMPANY_PERSON = 'company_person';
const ROLE_VICE_CARRIER_DIRECTOR = 'vice_carrier_director';

const ROLE_VALUES = [
  { Id: ROLE_COMPANY_PERSON, Name: 'Сотрудник компании' },
  { Id: ROLE_VICE_CARRIER_DIRECTOR, Name: 'Зам. директора' },
];

export default function ModalCreateEmployee({ isShow, setIsShow, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [secondName, setSecondName] = useState('');
  const [patronymic, setPatronymic] = useState('');
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordRepeat, setPasswordRepeat] = useState(null);
  const [role, setRole] = useState(ROLE_COMPANY_PERSON);
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [approvePhoneVisible, setApprovePhoneVisible] = useState(false);
  const [showDeactiveUserModal, setShowDeactiveUserModal] = useState(false);

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent" };
  let approveNumberButton = {height: '43px', background: '#2b3f63', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent", fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '500', lineHeight: '20px' };

  const onSubmitFormCreateEmployee = e => {
    e.preventDefault();

    setLoading(true);

    companyService
      .createEmployee({ phone, email, firstName, secondName, patronymic, password, passwordRepeat, role })
      .then(responseData => {
        if (responseData.status === "success") {
          notification.success({
            message: i18n.t('components.notification.titles.createEmployee'),
            description: responseData.message
          });
          setLoading(false);
          setIsShow(false);
          onSuccess();
        } else if (responseData.status === "error") {
          if (responseData.message) {
            notification.error({
              message: i18n.t('components.notification.titles.createEmployee'),
              description: responseData.message
            });
          }
          setLoading(false);
          if (responseData.errors) {
            setFieldsErrors(responseData.errors);
          }
          if (responseData.errors && responseData.errors.phone_used) {
            setApprovePhoneVisible(true);
          }
        }
      })
      .catch(errorMsg => {
        notification.error({
          message: i18n.t('components.notification.titles.createEmployee'),
          description: errorMsg
        });
        setLoading(false);
      });
  };

  const getFieldErrors = fieldName => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  return (
    <Modal
      title={i18n.t('modals.modalCreateEmployee.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[
        <Button htmlType="submit" key="submit" style={bigButtonStyle} type="primary" onClick={onSubmitFormCreateEmployee}>
          {i18n.t('main.buttons.create')}
        </Button>
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Form>
          <Row gutter={[16, 24]}>
            <Col lg={8} md={24} sm={24} xs={24}>
              <InputField name="firstName" label={i18n.t('modals.modalCreateEmployee.fields.firstName.title')} value={firstName} setValue={setFirstName} getFieldErrors={getFieldErrors} />
            </Col>
            <Col lg={8} md={24} sm={24} xs={24}>
              <InputField name="secondName" label={i18n.t('modals.modalCreateEmployee.fields.secondName.title')} value={secondName} setValue={setSecondName} getFieldErrors={getFieldErrors} />
            </Col>
            <Col lg={8} md={24} sm={24} xs={24}>
              <InputField name="patronymic" label={i18n.t('modals.modalCreateEmployee.fields.patronymic.title')} value={patronymic} setValue={setPatronymic} getFieldErrors={getFieldErrors} />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
                <InputField name="phone" label={i18n.t('modals.modalCreateEmployee.fields.phone.title')} mask="+7 (111) 111-11-11" value={phone} setValue={setPhone} getFieldErrors={getFieldErrors} />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <InputField name="email" label={i18n.t('modals.modalCreateEmployee.fields.email.title')} value={email} setValue={setEmail} getFieldErrors={getFieldErrors} />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <SelectField
                title={i18n.t('modals.modalCreateEmployee.fields.role.title')}
                name="role"
                selectedValue={role}
                values={ROLE_VALUES}
                onChange={value => setRole(value)}
                getErrors={getFieldErrors}
              />
            </Col>
          </Row>
          {approvePhoneVisible ? (
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Button
                style={approveNumberButton}
                htmlType="submit"
                type="primary"
                onClick={setShowDeactiveUserModal}
                key="get-codes"
              >
                {i18n.t('modals.modalCreateEmployee.buttons.access')}
              </Button>
              <ModalDeactiveUser isShow={showDeactiveUserModal} onCloseModal={setShowDeactiveUserModal} phone={phone} />
            </Col>
          </Row>) : null}
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <InputField name="password" label={i18n.t('modals.modalCreateEmployee.fields.password.title')} value={password} setValue={setPassword} getFieldErrors={getFieldErrors} type="password" />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <InputField
                name="passwordRepeat"
                type="password"
                label={i18n.t('modals.modalCreateEmployee.fields.passwordRepeat.title')}
                value={passwordRepeat}
                setValue={setPasswordRepeat}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
}